import { render, staticRenderFns } from "./IntegralOrder.vue?vue&type=template&id=8228c958&scoped=true&"
import script from "./IntegralOrder.vue?vue&type=script&lang=js&"
export * from "./IntegralOrder.vue?vue&type=script&lang=js&"
import style0 from "./IntegralOrder.vue?vue&type=style&index=0&id=8228c958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8228c958",
  null
  
)

export default component.exports